export default __webpack_public_path__ + "static/media/Magnetism_03.90815c32.png";